import React from "react";
import DashboardInstrumentTable from "./DashboardInstrumentTable";
import "./DashboardInstrument.css";

function DashboardInstrument() {
  return (
    <div className="DashboardInstrument__Container">
      <DashboardInstrumentTable />
    </div>
  );
}

export default DashboardInstrument;
